module.exports = __webpack_public_path__ + "img/icon-hs-audio.43a27b5b.svg";